import {
  TASK_CREATED,
  TASK_UPDATED,
  TASK_REMOVED,
  TASKS_FROM_SERVER
} from "./types";
import api from "../api/Planer";

/**
 * Returns an action that the specified task has been created
 * @param {Object} task
 */
export const taskCreated = task => ({
  type: TASK_CREATED,
  task
});

/**
 * Returns an action that the specified task has been updated
 * @param {Object} task
 */
export const taskUpdated = task => ({
  type: TASK_UPDATED,
  task
});

/**
 * Returns an action that the task with the given ID has been deleted
 * @param {Int} id
 */
export const taskRemoved = id => ({
  type: TASK_REMOVED,
  id
});

/**
 * Returns an action containing a requested list of tasks from the server.
 * @param {[Object]} tasks
 */
export const tasksFetched = tasks => ({ type: TASKS_FROM_SERVER, tasks });

/**
 * Dispatches a task synchronization via the API
 */
export const synchronizeTasks = () => dispatch =>
  api.Tasks.fetch().then(response => dispatch(tasksFetched(response)));

/**
 * Dispatches a task creation using the given task object via the API
 * @param {Object} task
 */
export const createTask = task => dispatch =>
  api.Tasks.createTask(task).then(response => dispatch(taskCreated(response)));

/**
 * Dispatches a task update setting the 'done' property via the API
 * @param {Int} taskIdentifier ID of the specified task
 * @param {Boolean} done Whether the specified task should be marked as done
 */
export const setTaskDone = (taskIdentifier, done) => dispatch =>
  api.Tasks.setTaskDone(taskIdentifier, done).then(response =>
    dispatch(taskUpdated(response))
  );

/**
 * Dispatches a task deletion via the API using a given task identifier
 * @param {Int} identifier ID of the task which should be deleted
 */
export const removeTask = identifier => dispatch =>
  api.Tasks.removeTask(identifier).then(() =>
    dispatch(taskRemoved(identifier))
  );



// WEBPACK FOOTER //
// ./src/actions/planer.js